import { ActionMenu } from "layouts/common/buttons";
import { TextLink } from "layouts/common/buttons";
import MDTypography from "ui/MDTypography";

export default function data(funds, handleDelete, setNotification) {

  const rows = () => {
    return funds?.map(group => {
      const { funddata, fundtype, date } = group; // grouped fund object

      // You can get creator info from first fund in the group
      const createdByName = funddata?.[0]?.createdBy?.name || "Unknown";

      return {
        fundtype: (
          <TextLink
            link={`/funds/${group.id}/detail`} // send date & fundtype
            text={fundtype || "N/A"}
          />
        ),
  
        date: (
          <MDTypography variant="caption" fontWeight="medium">
            {date}
          </MDTypography>
          
        ),
 
        dropdown: (
          <ActionMenu
            entity={group}
            basePath="fund"
            onDelete={() => handleDelete(group.id)}
            setNotification={setNotification} 
          />
        ),
      };
    });
  };

  return {
    columns: [
      { Header: "Fund Type", accessor: "fundtype", align: "left" },
      { Header: "Date", accessor: "date", align: "center" },
      { accessor: "dropdown", align: "right" },
    ],
    rows: rows()
  };
}